import { colors } from '@thndr/design-system';
import * as Styles from './disclaimer.styles';
export interface DisclaimerProps {
  text: string;
  bgColor?: keyof typeof colors | null;
  borderColor?: keyof typeof colors | null;
}

export function Disclaimer({
  text,
  bgColor = null,
  borderColor = null,
}: DisclaimerProps) {
  return (
    <Styles.Container bgColor={bgColor} borderColor={borderColor}>
      <Styles.Text>{text}</Styles.Text>
    </Styles.Container>
  );
}

export default Disclaimer;
